export const TALKING_ROLES = {
	USER: 'user',
	BOT: 'bot',
};
